import { useState, useEffect } from 'react'

const BASE_WIDTH = 1120

const useMobile = (): [boolean] => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < BASE_WIDTH);

  useEffect(() => {
    window.addEventListener("resize", windowResizeHandler, false);

    return window.removeEventListener('rersize', windowResizeHandler);
  }, [])


  const windowResizeHandler = (e: any) => {
    setIsMobile(window.innerWidth < BASE_WIDTH);
  }

  return [
    isMobile
 ]
}

export default useMobile;